
const JobListByCandidate = ()=>{
    return <div>
        
    </div>
}

export default JobListByCandidate